import { create } from 'zustand';

/**
 * 실시간 랭킹 지역 표시
 * */
export const useRealTimeRankingRegionStore = create<{
  region: RankingRegionType;
  updateRegion: (value: RankingRegionType) => void;
}>((set) => ({
  region: null,
  updateRegion: (value: RankingRegionType) =>
    set(() => ({
      region: value,
    })),
}));

/**
 * 실시간 랭킹 카테고리(성별) 표시
 * */
export const useRealTimeRankingCategoryStore = create<{
  category: CategoryType;
  updateCategory: (value: CategoryType) => void;
}>((set) => ({
  category: 'FEMALE',
  updateCategory: (value: CategoryType) =>
    set(() => ({
      category: value,
    })),
}));
